import React, { useEffect, useState } from 'react';
import { useMap, useMapEvent } from 'react-leaflet';
import L from 'leaflet';
import { useGlobalActiveGeography } from '../../data/StatusStore';

interface MapZoomControlProps {
  onClickButton: () => void;
}

const MapZoomControl: React.FC<MapZoomControlProps> = ({ onClickButton }) => {
  const map = useMap();
  const activeGeography = useGlobalActiveGeography();
  const [selectedValue, setSelectedValue] = useState<string>(activeGeography);

  useEffect(() => {
    const controlContainer = L.DomUtil.create('div', 'leaflet-control leaflet-bar');
    const customControl = new L.Control({ position: 'topright' });

    customControl.onAdd = function () {
      L.DomEvent.disableClickPropagation(controlContainer);
      return controlContainer;
    };

    customControl.addTo(map);

    return () => {
      customControl.remove();
    };
  }, [map]);

  useMapEvent('click', () => {
    // Optional: Respond to map clicks
  });

  const buttonStyle = {
    backgroundColor: "#fff",
    border: "1px solid #000",
    borderRadius: "4px",
    fontSize: "12px",
    textAlign: "center" as const,
    //boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
    padding: "3px 10px",
    cursor: "pointer",
    //marginBottom: "4px",
    width: "fit-content",
  };

  const smallButtonStyle = {
    ...buttonStyle,
    fontSize: "14px",
    padding: "2px 8px",
    marginTop: "4px",
    //marginBottom: "2px", // tighter vertical spacing
  };

  return (
    <div className="leaflet-control-container">
      <div className="leaflet-top leaflet-right">
        <div
          className="leaflet-control leaflet-control-custom"
          id="mapResetZoom"
          style={buttonStyle}
          onClick={(e) => {
            e.stopPropagation();
            onClickButton();
          }}
        >
          reset zoom
        </div>
        <div
          className="leaflet-control leaflet-control-custom"
          style={smallButtonStyle}
          onClick={(e) => {
            e.stopPropagation();
            map.zoomIn();
          }}
        >
          +
        </div>
        <div
          className="leaflet-control leaflet-control-custom"
          style={smallButtonStyle}
          onClick={(e) => {
            e.stopPropagation();
            map.zoomOut();
          }}
        >
          −
        </div>
      </div>
    </div>
  );
};

export default MapZoomControl;
